export const filterSupportedSampleTypes = (supportedSampleTypes, isIllumina) => {
    const sampleTypes = (supportedSampleTypes || []).map((sampleType) => sampleType.attributes.name);
    return isIllumina
        ? ['isolate']
        : sampleTypes.filter(type => ['isolate', 'respiratory', 'metagenomic'].includes(type));
}